<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12"  v-if="userRole =='Admin' ">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" md="6"  class="pt-2" >
                    <span >Super Admins</span>
                  </b-col>
                
                </b-row>
              </b-col>
              
              <b-col v-if="updateName=='Administrators'" cols="6" >
                <b-row class="justify-content-md-end">
                  <b-button class="buttonlink"   router-link :to="{ name: 'Add Admin', params: { adrole: 'Admin'} }"  variant="link" style="color:#006837"><b>+ Add Super Admin</b></b-button>
                     <!-- <addAdmins v-bind:addshow="addsadmin"/> -->
                     <!-- <addAdmins/> -->
                </b-row>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="users"
            :fields="superfields"
            @row-clicked="rowClicked"
          >
            <template slot="photo" slot-scope="data">
              <img v-if="data.item.photo" :src="baseURL+'/u/'+data.item.photo" />
              <span v-else>-</span>
            </template>
            <template slot="name" slot-scope="data">
              <strong v-if="data.item.name">{{data.item.name}}</strong>
              <span v-else>-</span>
            </template>
            <template slot="phone" slot-scope="data">
              <span v-if="data.item.phone">{{data.item.phonePrefix}}&nbsp;{{data.item.phone}}</span>
              <span v-else>-</span>
            </template>
            <template slot="country" slot-scope="data">
              <span v-if="data.item.country">{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
            <template slot="age" slot-scope="data">
              <span v-if="data.item.age">{{data.item.age}}</span>
              <span v-else>-</span>
            </template>
            <template slot="gender" slot-scope="data">
              <span v-if="data.item.gender">{{data.item.gender}}</span>
              <span v-else>-</span>
            </template>
            <template slot="occupation" slot-scope="data">
              <span v-if="data.item.occupation">{{data.item.occupation}}</span>
              <span v-else>-</span>
            </template>
           
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totaladminUsers"
              :per-page="perPage"
              v-model="currentadminPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextadminPage"
            />
          </nav>
         
        </b-card>
      </transition>
    </b-col>

    <b-col cols="12" xl="12"  v-if="userRole =='Admin'">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" md="6"  class="pt-2">
                    <span >Country Admins</span>
                  </b-col>
                 
                </b-row>
              </b-col>
              
              <b-col v-if="updateName=='Administrators'" cols="6" >
                <b-row class="justify-content-md-end">
                      <b-button class="buttonlink"   router-link :to="{ name: 'Add Admin', params: { adrole: 'CountryAdmin'} }"  variant="link" style="color:#006837"><b>+ Add Country Admin</b></b-button>
                     <!-- <b-button class="buttonlink"  @click="cadminadd" v-b-modal.modal-lg variant="link" style="color:#006837"><b>+ Add Country Admin</b></b-button>
                     <addAdmins v-bind:addshow="addcadmin"/> -->
                </b-row>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="countryusers"
            :fields="countryfields"
            @row-clicked="countryadminrowClicked"
          >
            <template slot="photo" slot-scope="data">
              <img v-if="data.item.photo" :src="baseURL+'/u/'+data.item.photo" />
              <span v-else>-</span>
            </template>
            <template slot="name" slot-scope="data">
              <strong v-if="data.item.name">{{data.item.name}}</strong>
              <span v-else>-</span>
            </template>
            <template slot="phone" slot-scope="data">
              <span v-if="data.item.phone">{{data.item.phonePrefix}}&nbsp;{{data.item.phone}}</span>
              <span v-else>-</span>
            </template>
            <template slot="country" slot-scope="data">
              <span v-if="data.item.country">{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
            <template slot="age" slot-scope="data">
              <span v-if="data.item.age">{{data.item.age}}</span>
              <span v-else>-</span>
            </template>
            <template slot="gender" slot-scope="data">
              <span v-if="data.item.gender">{{data.item.gender}}</span>
              <span v-else>-</span>
            </template>
            <template slot="occupation" slot-scope="data">
              <span v-if="data.item.occupation">{{data.item.occupation}}</span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="_id" slot-scope="data">
              <b-button size="sm" variant="success">View</b-button>
            </template>-->
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalcountryUsers"
              :per-page="perPage"
              v-model="currentcountryadminPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextcountryadminPage"
            />
          </nav>
         
        </b-card>
      </transition>
    </b-col>

    <b-col cols="12" xl="12" v-if="userRole =='Admin' || userRole =='CountryAdmin'">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" md="6"  class="pt-2">
                    <span>State Admins</span>
                  </b-col>
                 
                </b-row>
              </b-col>
              
              <b-col v-if="updateName=='Administrators'" cols="6" >
                <b-row class="justify-content-md-end">
                   <b-button class="buttonlink"   router-link :to="{ name: 'Add Admin', params: { adrole: 'StateAdmin'} }"  variant="link" style="color:#006837"><b>+ Add State Admin</b></b-button>
                  <!-- <b-button class="buttonlink"  @click="stadminadd" v-b-modal.modal-lg variant="link" style="color:#006837"><b>+ Add State Admin</b></b-button>
                     <addAdmins v-bind:addshow="addstadmin"/> -->
                </b-row>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="stateusers"
            :fields="statefields"
            @row-clicked="stateadminrowClicked"
          >
            <template slot="photo" slot-scope="data">
              <img v-if="data.item.photo" :src="baseURL+'/u/'+data.item.photo" />
              <span v-else>-</span>
            </template>
            <template slot="name" slot-scope="data">
              <strong v-if="data.item.name">{{data.item.name}}</strong>
              <span v-else>-</span>
            </template>
            <template slot="phone" slot-scope="data">
              <span v-if="data.item.phone">{{data.item.phonePrefix}}&nbsp;{{data.item.phone}}</span>
              <span v-else>-</span>
            </template>
            <template slot="country" slot-scope="data">
              <span v-if="data.item.country">{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
             <template slot="state" slot-scope="data">
              <span v-if="data.item.state">{{data.item.state}}</span>
              <span v-else>-</span>
            </template>
            <template slot="age" slot-scope="data">
              <span v-if="data.item.age">{{data.item.age}}</span>
              <span v-else>-</span>
            </template>
            <template slot="gender" slot-scope="data">
              <span v-if="data.item.gender">{{data.item.gender}}</span>
              <span v-else>-</span>
            </template>
            <template slot="occupation" slot-scope="data">
              <span v-if="data.item.occupation">{{data.item.occupation}}</span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="_id" slot-scope="data">
              <b-button size="sm" variant="success">View</b-button>
            </template>-->
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalstateUsers"
              :per-page="perPage"
              v-model="currentstateadminPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextstateadminPage"
            />
          </nav>
         
        </b-card>
      </transition>
    </b-col>

    <b-col cols="12" xl="12" v-if="userRole =='Admin' || userRole =='CountryAdmin' || userRole=='StateAdmin'" >
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" md="6"  class="pt-2">
                    <span>City Admins</span>
                  </b-col>
                 
                </b-row>
              </b-col>
              
              <b-col v-if="updateName=='Administrators'" cols="6" >
                <b-row class="justify-content-md-end">
                   <b-button class="buttonlink"   router-link :to="{ name: 'Add Admin', params: { adrole: 'CityAdmin'} }"  variant="link" style="color:#006837"><b>+ Add City Admin</b></b-button>
                  <!-- <b-button class="buttonlink"  @click="ctadminadd" v-b-modal.modal-lg variant="link" style="color:#006837"><b>+ Add city Admin</b></b-button>
                     <addAdmins v-bind:addshow="addctadmin"/> -->
                </b-row>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="cityusers"
            :fields="cityfields"
            @row-clicked="cityadminrowClicked"
          >
            <template slot="photo" slot-scope="data">
              <img v-if="data.item.photo" :src="baseURL+'/u/'+data.item.photo" />
              <span v-else>-</span>
            </template>
            <template slot="name" slot-scope="data">
              <strong v-if="data.item.name">{{data.item.name}}</strong>
              <span v-else>-</span>
            </template>
            <template slot="phone" slot-scope="data">
              <span v-if="data.item.phone">{{data.item.phonePrefix}}&nbsp;{{data.item.phone}}</span>
              <span v-else>-</span>
            </template>
            <template slot="country" slot-scope="data">
              <span v-if="data.item.country">{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
            <template slot="state" slot-scope="data">
              <span v-if="data.item.state">{{data.item.state}}</span>
              <span v-else>-</span>
            </template>
             <template slot="city" slot-scope="data">
              <span v-if="data.item.city">{{data.item.city}}</span>
              <span v-else>-</span>
            </template>
            <template slot="country" slot-scope="data">
              <span v-if="data.item.country">{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
            <template slot="age" slot-scope="data">
              <span v-if="data.item.age">{{data.item.age}}</span>
              <span v-else>-</span>
            </template>
            <template slot="gender" slot-scope="data">
              <span v-if="data.item.gender">{{data.item.gender}}</span>
              <span v-else>-</span>
            </template>
            <template slot="occupation" slot-scope="data">
              <span v-if="data.item.occupation">{{data.item.occupation}}</span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="_id" slot-scope="data">
              <b-button size="sm" variant="success">View</b-button>
            </template>-->
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalcityUsers"
              :per-page="perPage"
              v-model="currentcityadminPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextcityadminPage"
            />
          </nav>
         
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import addAdmins from "./addAdmins";
import addtests from "./addtest";
export default {
    components:{
    addAdmins,
    addtests
    },
  data() {
    return {
      loginData:{},
      users: [],
      countryusers: [],
      stateusers: [],
      cityusers: [],
      superfields: [
        { key: "name", label: "Name", sortable: true },
        { key: "phone", label: "Phone", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "age", label: "Age", sortable: true },
        { key: "gender", label: "Gender", sortable: true },
        { key: "occupation", label: "Occupation", sortable: true }
      ],
      countryfields: [
        { key: "name", label: "Name", sortable: true },
        { key: "phone", label: "Phone", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "age", label: "Age", sortable: true },
        { key: "gender", label: "Gender", sortable: true },
        { key: "occupation", label: "Occupation", sortable: true }
      ],
      statefields: [
        { key: "name", label: "Name", sortable: true },
        { key: "phone", label: "Phone", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "state", label: "State", sortable: true },
        { key: "age", label: "Age", sortable: true },
        { key: "gender", label: "Gender", sortable: true },
        { key: "occupation", label: "Occupation", sortable: true }
      ],
      cityfields: [
        { key: "name", label: "Name", sortable: true },
        { key: "phone", label: "Phone", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "state", label: "State", sortable: true },
        { key: "city", label: "City", sortable: true },
        { key: "age", label: "Age", sortable: true },
        { key: "gender", label: "Gender", sortable: true },
        { key: "occupation", label: "Occupation", sortable: true }
      ],
      totaladminUsers: 0,
      totalcountryUsers: 0,
      totalstateUsers: 0,
      totalcityUsers: 0,
      currentadminPage: 1,
      currentcountryadminPage: 1,
      currentstateadminPage: 1,
      currentcityadminPage: 1,
      perPage: 10,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      addshow:false,
      addsadmin:false,
      addcadmin:false,
      addstadmin:false,
      addctadmin:false,
      updateName: "Administrators",
      userTypes: [
        // { name: "All Users", route: "/user/allUsers" },
        // { name: "Clients", route: "/user/allClients" },
        // { name: "Administrators", route: "/user/allAdmins" },
        // { name: "Deactivated Users", route: "/user/bannedusers" }
      ],
      currentUser: null,
      userRole: localStorage.getItem("role"),
    };
  },
  mounted() {
    this.getadminData();
    this.getcountryadminData();
    this.getstateadminData();
    this.getcityadminData();
  },
  methods: {
    nextadminPage(ev) {
      this.currentadminPage = ev;
      this.getadminData(this.currentUser);
    },
    nextcountryadminPage(ev) {
      this.currentcountryadminPage = ev;
      this.getcountryadminData(this.currentUser);
    },
    nextstateadminPage(ev) {
      this.currentstateadminPage = ev;
      this.getstateadminData(this.currentUser);
    },
    nextcityadminPage(ev) {
      this.currentcityadminPage = ev;
      this.getcityadminData(this.currentUser);
    },
    getadminData(item) {
      this.appLoading = true;
      axios({
        url:'/user/allUsers',
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          type:'Admin',
          count: this.perPage,
          page: this.currentadminPage
        }
      })
        .then(response => {
          this.users = response.data.data;
          this.totaladminUsers = response.data.count;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
     getcountryadminData() {
      this.appLoading = true;
      axios({
        url:'/user/allUsers',
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          type:'CountryAdmin',
          count: this.perPage,
          page: this.currentcountryadminPage
        }
      })
        .then(response => {
          this.countryusers = response.data.data;
          this.totalcountryUsers = response.data.count;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    getstateadminData() {
      this.appLoading = true;
      axios({
        url:'/user/allUsers',
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          type:'StateAdmin',
          count: this.perPage,
          page: this.currentstateadminPage
        }
      })
        .then(response => {
          this.stateusers = response.data.data;
          this.totalstateUsers = response.data.count;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    getcityadminData() {
      this.appLoading = true;
      axios({
        url:'/user/allUsers',
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          type:'CityAdmin',
          count: this.perPage,
          page: this.currentcityadminPage
        }
      })
        .then(response => {
          this.cityusers = response.data.data;
          this.totalcityUsers = response.data.count;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    sadminadd(){
        this.addsadmin=true;
        this.addcadmin=false;
        this.addstadmin=false;
        this.addctadmin=false;
    },
   
    cadminadd(){
        this.addsadmin=false;
        this.addcadmin=true;
        this.addstadmin=false;
        this.addctadmin=false;
    },
    stadminadd(){
        this.addsadmin=false;
        this.addcadmin=false;
        this.addstadmin=true;
        this.addctadmin=false;
    },
    ctadminadd(){
        this.addsadmin=false;
        this.addcadmin=false;
        this.addstadmin=false;
        this.addctadmin=true;
    },
    rowClicked(item) {
      this.$router.push("/Admins/" + item._id);
    },

    countryadminrowClicked(item) {
      this.$router.push("/countryAdmin/" + item._id);
    },
     stateadminrowClicked(item) {
      this.$router.push("/stateAdmin/" + item._id);
    },
     cityadminrowClicked(item) {
      this.$router.push("/cityAdmin/" + item._id);
    },
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}

.buttonlink{
    text-decoration: none;
}
</style>
